// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import PageHeader from '../components/PageHeader';
// import Card, { CardHeader } from '../components/Card';
// import DataTable, { Column } from '../components/DataTable';
// import Button from '../components/Button';
// import Badge, { statusToTone } from '../components/Badge';
// import ConfirmDialog from '../components/ConfirmDialog';
// import Toast, { ToastMessage } from '../components/Toast';
// import { BaseUrl } from '../services/adminApi';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faRotateRight,
//   faUserXmark,
//   faXmark,
//   faMagnifyingGlass,
//   faChevronLeft,
//   faChevronRight,
// } from '@fortawesome/free-solid-svg-icons';

// interface ReminderInfo {
//   label: string;
//   due: boolean;
// }

// interface SubscriptionRow {
//   id: number;
//   subscriber_name: string;
//   subscriber_email?: string;
//   plan_name: string;

//   status: string;
//   payment_status: string;

//   amount: number;
//   currency_symbol?: string; // not always returned by the API — we default it

//   expiry: string;
//   days: number;
//   reminders: ReminderInfo[];
// }

// interface RenewalsListResponse {
//   count: number;
//   next: string | null;
//   previous: string | null;
//   results: SubscriptionRow[];
// }

// interface RenewInitiateResponse {
//   message: string;
//   old_subscription_id: number;
//   new_subscription_id: number;
//   order_id: number;
//   order_code: string;
//   remaining_days_carried_forward: number;
//   new_start_date: string;
//   new_end_date: string;
//   status: string;
//   payment_status: string;
// }

// interface RenewConfirmResponse {
//   message: string;
//   subscription_id: number;
//   order_id: number;
//   order_code: string;
//   status: string;
//   payment_status: string;
//   new_end_date: string;
//   invoice: {
//     invoice_id: number;
//     invoice_number: string;
//     amount: string;
//     currency: string;
//     status: string;
//     payment_date: string;
//   };
// }

// const PAGE_SIZE = 10;

// function formatDate(iso: string | null) {
//   if (!iso || iso === '—') return '—';
//   return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
// }

// function formatAmount(row: SubscriptionRow) {
//   const symbol = row.currency_symbol ?? '₹';
//   return `${symbol}${Number(row.amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
// }

// export const RenewSubscription = () => {
//   const [rows, setRows] = useState<SubscriptionRow[]>([]);
//   const [count, setCount] = useState(0);
//   const [loading, setLoading] = useState(true);

//   const [searchInput, setSearchInput] = useState('');
//   const [search, setSearch] = useState('');
//   const [pageNum, setPageNum] = useState(1);

//   // The row currently targeted by the renew modal / lapse dialog — not a
//   // single fixed subscription, since this page now lists many.
//   const [selected, setSelected] = useState<SubscriptionRow | null>(null);
//   const [months, setMonths] = useState(1);
//   const [renewing, setRenewing] = useState(false);
//   const [confirming, setConfirming] = useState(false);
//   const [pendingRenewal, setPendingRenewal] = useState<RenewInitiateResponse | null>(null);
//   const [renewModalOpen, setRenewModalOpen] = useState(false);

//   const [lapseTarget, setLapseTarget] = useState<SubscriptionRow | null>(null);
//   const [lapseConfirmOpen, setLapseConfirmOpen] = useState(false);
//   const [lapsing, setLapsing] = useState(false);

//   const [toast, setToast] = useState<ToastMessage | null>(null);

//   const showToast = (text: string, type: ToastMessage['type'] = 'success') => {
//     setToast({ text, type });
//     setTimeout(() => setToast(null), 3000);
//   };

//   // Debounce the search box so we don't fire a request on every keystroke.
//   useEffect(() => {
//     const t = setTimeout(() => {
//       setPageNum(1);
//       setSearch(searchInput.trim());
//     }, 350);
//     return () => clearTimeout(t);
//   }, [searchInput]);

//   const fetchRenewals = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get<RenewalsListResponse>(BaseUrl + 'admin/renewals/', {
//         params: { search, pageNum, pageSize: PAGE_SIZE },
//       });
//       setRows(res.data.results);
//       setCount(res.data.count);
//     } catch {
//       showToast('Could not load renewals. Please try again.', 'error');
//       setRows([]);
//       setCount(0);
//     } finally {
//       setLoading(false);
//     }
//   }, [search, pageNum]);

//   useEffect(() => {
//     fetchRenewals();
//   }, [fetchRenewals]);

//   const totalPages = Math.max(1, Math.ceil(count / PAGE_SIZE));

//   const openRenewModal = (row: SubscriptionRow) => {
//     setSelected(row);
//     setMonths(1);
//     setPendingRenewal(null);
//     setRenewModalOpen(true);
//   };

//   const closeRenewModal = () => {
//     setRenewModalOpen(false);
//     setPendingRenewal(null);
//     setSelected(null);
//   };

//   const createRenewal = async () => {
//     if (!selected) return;
//     setRenewing(true);
//     try {
//       const res = await axios.post<RenewInitiateResponse>(
//         BaseUrl + `admin/subscriptions/${selected.id}/renew/`,
//         // { months }
//       );
//       setPendingRenewal(res.data);
//     } catch {
//       showToast('Could not create the renewal order. Please try again.', 'error');
//     } finally {
//       setRenewing(false);
//     }
//   };

//   const confirmPayment = async () => {
//     if (!pendingRenewal || !selected) return;
//     setConfirming(true);
//     try {
//       await axios.post<RenewConfirmResponse>(
//         BaseUrl + `admin/subscriptions/${pendingRenewal.new_subscription_id}/renew/confirm/`
//       );
//       showToast(`${selected.subscriber_name}'s subscription renewed.`);
//       closeRenewModal();
//       fetchRenewals(); // pull the updated row (new id, new expiry) from the server
//     } catch {
//       showToast('Could not confirm the payment. Please try again.', 'error');
//     } finally {
//       setConfirming(false);
//     }
//   };

//   const openLapseConfirm = (row: SubscriptionRow) => {
//     setLapseTarget(row);
//     setLapseConfirmOpen(true);
//   };

//   const confirmMarkAsLapsed = async () => {
//     if (!lapseTarget) return;
//     setLapsing(true);
//     try {
//       await axios.post(BaseUrl + `admin/subscriptions/${lapseTarget.id}/mark-lapsed/`, {});
//     } catch {
//       // Backend mark-lapsed endpoint may not exist yet — proceed anyway so
//       // the admin panel stays usable while it's being built out.
//     }
//     showToast(`${lapseTarget.subscriber_name}'s subscription marked as lapsed.`);
//     setLapsing(false);
//     setLapseConfirmOpen(false);
//     setLapseTarget(null);
//     fetchRenewals(); // the lapsed subscriber should drop out of this list
//   };

//   const canAct = (row: SubscriptionRow) =>
//     row.status?.toLowerCase() !== 'expired' && row.status?.toLowerCase() !== 'cancelled';

//   const columns: Column<SubscriptionRow>[] = [
//     {
//       key: 'user', header: 'Subscriber', render: r => (
//         <div className="flex items-center gap-3">
//           <div className="w-9 h-9 rounded-full bg-navy text-white flex items-center justify-center font-black text-[12px] shrink-0">
//             {r.subscriber_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
//           </div>
//           <div>
//             <p className="font-bold text-gray-900">{r.subscriber_name}</p>
//             {r.subscriber_email && <p className="text-[11px] text-gray-400 font-medium">{r.subscriber_email}</p>}
//           </div>
//         </div>
//       )
//     },
//     { key: 'plan', header: 'Plan', render: r => r.plan_name },
//     { key: 'expiry', header: 'Expiry', render: r => formatDate(r.expiry) },
//     {
//       key: 'days',
//       header: 'Days',
//       render: r => (
//         <span className={r.days <= 0 ? 'text-red-600 font-semibold' : ''}>
//           {r.days}d
//         </span>
//       ),
//     },
//     {
//       key: 'reminders',
//       header: 'Reminders',
//       render: r => (
//         <div className="flex flex-col gap-1">
//           {r.reminders?.map((rem, idx) => (
//             <span
//               key={idx}
//               className={`px-2 py-0.5 text-xs rounded-full border w-fit ${
//                 rem.due
//                   ? 'bg-amber-100 text-amber-700 border-amber-200'
//                   : 'bg-green-100 text-green-700 border-green-200'
//               }`}
//             >
//               ⟳ {rem.label}
//             </span>
//           ))}
//         </div>
//       ),
//     },
//     {
//       key: 'status', header: 'Status', render: r => (
//         <Badge tone={statusToTone(r.status)}>{r.status}</Badge>
//       )
//     },
//     {
//       key: 'payment_status', header: 'Payment', render: r => (
//         <Badge tone={r.payment_status?.toLowerCase() === 'paid' ? 'green' : 'amber'}>{r.payment_status || '—'}</Badge>
//       )
//     },
//     { key: 'amount', header: 'Amount', render: r => formatAmount(r), align: 'right' },
//     {
//       key: 'actions', header: '', align: 'right', render: r => (
//         <div className="flex items-center justify-end gap-1.5">
//           <button
//             title="Renew"
//             onClick={() => openRenewModal(r)}
//             disabled={!canAct(r)}
//             className="w-8 h-8 rounded-lg flex items-center justify-center text-navy hover:text-navy hover:bg-gray-50 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-400"
//           >
//             <FontAwesomeIcon icon={faRotateRight} className="text-[13px]" />
//           </button>
//           <button
//             title="Mark as lapsed"
//             onClick={() => openLapseConfirm(r)}
//             disabled={!canAct(r)}
//             className="w-8 h-8 rounded-lg flex items-center justify-center text-red-600 hover:text-red-600 hover:bg-red-50 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-400"
//           >
//             <FontAwesomeIcon icon={faUserXmark} className="text-[13px]" />
//           </button>
//         </div>
//       )
//     },
//   ];

//   return (
//     <div>
//       <PageHeader
//         title="Renewals"
//         subtitle="Subscriptions due or coming due for renewal."
//       />

//       <Card>
//         <CardHeader title="Subscriptions" subtitle="" />

//         <div className="flex items-center justify-between gap-3 px-1 pb-4">
//           <div className="relative w-full max-w-xs">
//             <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300 text-[12px]" />
//             <input
//               type="text"
//               value={searchInput}
//               onChange={e => setSearchInput(e.target.value)}
//               placeholder="Search by subscriber, plan…"
//               className="w-full pl-8 pr-3 py-2 text-[13px] font-medium border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/20 focus:border-navy"
//             />
//           </div>
//           <span className="text-[12px] text-gray-400 font-semibold whitespace-nowrap">
//             {count} {count === 1 ? 'result' : 'results'}
//           </span>
//         </div>

//         <DataTable
//           columns={columns}
//           rows={rows}
//           loading={loading}
//           emptyTitle="No renewals found"
//           emptySubtitle={search ? 'Try a different search term.' : 'Nothing is due for renewal right now.'}
//         />

//         {count > PAGE_SIZE && (
//           <div className="flex items-center justify-between px-1 pt-4">
//             <span className="text-[12px] text-gray-400 font-semibold">
//               Page {pageNum} of {totalPages}
//             </span>
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => setPageNum(p => Math.max(1, p - 1))}
//                 disabled={pageNum <= 1 || loading}
//                 className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:hover:bg-transparent"
//               >
//                 <FontAwesomeIcon icon={faChevronLeft} className="text-[12px]" />
//               </button>
//               <button
//                 onClick={() => setPageNum(p => Math.min(totalPages, p + 1))}
//                 disabled={pageNum >= totalPages || loading}
//                 className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:hover:bg-transparent"
//               >
//                 <FontAwesomeIcon icon={faChevronRight} className="text-[12px]" />
//               </button>
//             </div>
//           </div>
//         )}
//       </Card>

//       {/* Renew modal — step 1: pick duration & create the order. step 2: confirm payment received. */}
//       {renewModalOpen && selected && (
//         <div
//           className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
//           onClick={() => !renewing && !confirming && closeRenewModal()}
//         >
//           <div
//             className="bg-white rounded-lg shadow-xl w-full max-w-md p-6"
//             onClick={e => e.stopPropagation()}
//           >
//             <div className="flex items-start justify-between mb-4">
//               <div>
//                 <h3 className="text-[15px] font-black text-gray-900">Renew subscription</h3>
//                 <p className="text-[12px] text-gray-500 font-medium mt-0.5">
//                   {selected.subscriber_name} · {selected.plan_name}
//                 </p>
//               </div>
//               <button
//                 onClick={closeRenewModal}
//                 disabled={renewing || confirming}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <FontAwesomeIcon icon={faXmark} />
//               </button>
//             </div>

//      {!pendingRenewal ? (
//   <>
//     <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 mb-6 space-y-2">
//       <div className="flex items-center justify-between">
//         <span className="text-[12px] font-bold text-gray-500">Customer</span>
//         <span className="text-[13px] font-black text-gray-900">{selected.subscriber_name}</span>
//       </div>
//       {selected.subscriber_email && (
//         <div className="flex items-center justify-between">
//           <span className="text-[12px] font-bold text-gray-500">Email</span>
//           <span className="text-[13px] font-semibold text-gray-700 truncate max-w-[220px]">
//             {selected.subscriber_email}
//           </span>
//         </div>
//       )}
//       <div className="flex items-center justify-between">
//         <span className="text-[12px] font-bold text-gray-500">Plan</span>
//         <span className="text-[13px] font-black text-gray-900">{selected.plan_name}</span>
//       </div>
//       <div className="flex items-center justify-between">
//         <span className="text-[12px] font-bold text-gray-500">Amount</span>
//         <span className="text-[13px] font-black text-gray-900">{formatAmount(selected)}</span>
//       </div>
//       {selected.reminders?.length > 0 && (
//         <div className="flex items-start justify-between pt-1">
//           <span className="text-[12px] font-bold text-gray-500 pt-0.5">Reminders</span>
//           <div className="flex flex-col items-end gap-1">
//             {selected.reminders.map((rem, idx) => (
//               <span
//                 key={idx}
//                 className={`px-2 py-0.5 text-xs rounded-full border w-fit ${
//                   rem.due
//                     ? 'bg-amber-100 text-amber-700 border-amber-200'
//                     : 'bg-green-100 text-green-700 border-green-200'
//                 }`}
//               >
//                 ⟳ {rem.label}
//               </span>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>

//     <div className="flex items-center justify-end gap-2">
//       <Button variant="secondary" size="sm" onClick={closeRenewModal} disabled={renewing}>
//         Cancel
//       </Button>
//       <Button
//         variant="primary"
//         size="sm"
//         onClick={createRenewal}
//         loading={renewing}
//         icon={<FontAwesomeIcon icon={faRotateRight} />}
//       >
//         Create renewal order
//       </Button>
//     </div>
//   </>
// ) : (

//               <>
//                 <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 mb-6 space-y-2">
//                   <div className="flex items-center justify-between">
//                     <span className="text-[12px] font-bold text-gray-500">Order</span>
//                     <span className="text-[13px] font-black text-gray-900">{pendingRenewal.order_code}</span>
//                   </div>
//                   <div className="flex items-center justify-between">
//                     <span className="text-[12px] font-bold text-gray-500">New end date</span>
//                     <span className="text-[13px] font-black text-gray-900">{formatDate(pendingRenewal.new_end_date)}</span>
//                   </div>
//                   <div className="flex items-center justify-between">
//                     <span className="text-[12px] font-bold text-gray-500">Days carried forward</span>
//                     <span className="text-[13px] font-black text-gray-900">{pendingRenewal.remaining_days_carried_forward}d</span>
//                   </div>
//                   <div className="flex items-center justify-between">
//                     <span className="text-[12px] font-bold text-gray-500">Payment status</span>
//                     <Badge tone="amber">{pendingRenewal.payment_status}</Badge>
//                   </div>
//                 </div>

//                 <p className="text-[12px] text-gray-500 font-medium mb-6">
//                   Collect payment for this order outside this screen, then confirm below once it's been received.
//                 </p>

//                 <div className="flex items-center justify-end gap-2">
//                   <Button variant="secondary" size="sm" onClick={closeRenewModal} disabled={confirming}>
//                     Cancel
//                   </Button>
//                   <Button
//                     variant="primary"
//                     size="sm"
//                     onClick={confirmPayment}
//                     loading={confirming}
//                     icon={<FontAwesomeIcon icon={faRotateRight} />}
//                   >
//                     Confirm payment received
//                   </Button>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       <ConfirmDialog
//         open={lapseConfirmOpen}
//         onClose={() => !lapsing && setLapseConfirmOpen(false)}
//         onConfirm={confirmMarkAsLapsed}
//         title="Mark as lapsed"
//         message={lapseTarget ? `Mark ${lapseTarget.subscriber_name}'s "${lapseTarget.plan_name}" subscription as lapsed? They'll lose access until it's renewed, and this subscriber will move to the Lapsed list.` : ''}
//         confirmLabel="Mark as lapsed"
//         danger
//         loading={lapsing}
//       />

//       <Toast message={toast} />
//     </div>
//   );
// }

// export default RenewSubscription;
import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import PageHeader from '../components/PageHeader';
import Card, { CardHeader } from '../components/Card';
import DataTable, { Column } from '../components/DataTable';
import Button from '../components/Button';
import Badge, { statusToTone } from '../components/Badge';
import ConfirmDialog from '../components/ConfirmDialog';
import Toast, { ToastMessage } from '../components/Toast';
import { BaseUrl } from '../services/adminApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRotateRight,
  faUserXmark,
  faXmark,
  faMagnifyingGlass,
  faChevronLeft,
  faChevronRight,
  faCreditCard,
} from '@fortawesome/free-solid-svg-icons';

interface ReminderInfo {
  label: string;
  due: boolean;
}

interface SubscriptionRow {
  id: number;
  subscriber_name: string;
  subscriber_email?: string;
  plan_name: string;

  status: string;
  payment_status: string;

  amount: number;
  currency_symbol?: string;

  expiry: string;
  days: number;
  reminders: ReminderInfo[];
}

interface RenewalsListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: SubscriptionRow[];
}

interface RenewInitiateResponse {
  message: string;
  old_subscription_id: number;
  new_subscription_id: number;
  order_id: number;
  order_code: string;
  remaining_days_carried_forward: number;
  new_start_date: string;
  new_end_date: string;
  status: string;
  payment_status: string;

  // --- Razorpay fields (ASSUMED shape — confirm against actual API) ---
  razorpay_key_id?: string;
  razorpay_order_id?: string;
  amount?: number; // in paise, as Razorpay expects
  currency?: string; // e.g. "INR"
}

interface RenewConfirmResponse {
  message: string;
  subscription_id: number;
  order_id: number;
  order_code: string;
  status: string;
  payment_status: string;
  new_end_date: string;
  invoice: {
    invoice_id: number;
    invoice_number: string;
    amount: string;
    currency: string;
    status: string;
    payment_date: string;
  };
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

const RAZORPAY_CHECKOUT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

function loadRazorpayScript(): Promise<boolean> {
  return new Promise(resolve => {
    if (document.querySelector(`script[src="${RAZORPAY_CHECKOUT_SRC}"]`)) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = RAZORPAY_CHECKOUT_SRC;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

const PAGE_SIZE = 10;

function formatDate(iso: string | null) {
  if (!iso || iso === '—') return '—';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

function formatAmount(row: SubscriptionRow) {
  const symbol = row.currency_symbol ?? '₹';
  return `${symbol}${Number(row.amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

export const RenewSubscription = () => {
  const [rows, setRows] = useState<SubscriptionRow[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [pageNum, setPageNum] = useState(1);

  const [selected, setSelected] = useState<SubscriptionRow | null>(null);
  const [/* months */, setMonths] = useState(1);
  const [renewing, setRenewing] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [pendingRenewal, setPendingRenewal] = useState<RenewInitiateResponse | null>(null);
  const [renewModalOpen, setRenewModalOpen] = useState(false);
  const razorpayReady = useRef(false);

  const [lapseTarget, setLapseTarget] = useState<SubscriptionRow | null>(null);
  const [lapseConfirmOpen, setLapseConfirmOpen] = useState(false);
  const [lapsing, setLapsing] = useState(false);

  const [toast, setToast] = useState<ToastMessage | null>(null);

  const showToast = (text: string, type: ToastMessage['type'] = 'success') => {
    setToast({ text, type });
    setTimeout(() => setToast(null), 3000);
  };

  useEffect(() => {
    loadRazorpayScript().then(ok => {
      razorpayReady.current = ok;
    });
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      setPageNum(1);
      setSearch(searchInput.trim());
    }, 350);
    return () => clearTimeout(t);
  }, [searchInput]);

  const fetchRenewals = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get<RenewalsListResponse>(BaseUrl + 'admin/renewals/', {
        params: { search, pageNum, pageSize: PAGE_SIZE },
      });
      setRows(res.data.results);
      setCount(res.data.count);
    } catch {
      showToast('Could not load renewals. Please try again.', 'error');
      setRows([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [search, pageNum]);

  useEffect(() => {
    fetchRenewals();
  }, [fetchRenewals]);

  const totalPages = Math.max(1, Math.ceil(count / PAGE_SIZE));

  const openRenewModal = (row: SubscriptionRow) => {
    setSelected(row);
    setMonths(1);
    setPendingRenewal(null);
    setRenewModalOpen(true);
  };

  const closeRenewModal = () => {
    setRenewModalOpen(false);
    setPendingRenewal(null);
    setSelected(null);
  };

  const createRenewal = async () => {
    if (!selected) return;
    setRenewing(true);
    try {
      const res = await axios.post<RenewInitiateResponse>(
        BaseUrl + `admin/subscriptions/${selected.id}/renew/`
      );
      setPendingRenewal(res.data);
    } catch {
      showToast('Could not create the renewal order. Please try again.', 'error');
    } finally {
      setRenewing(false);
    }
  };

  const confirmPaymentWithRazorpay = async (razorpayResponse: {
    razorpay_payment_id: string;
    razorpay_order_id: string;
    razorpay_signature: string;
  }) => {
    if (!pendingRenewal || !selected) return;
    setConfirming(true);
    try {
      await axios.post<RenewConfirmResponse>(
        BaseUrl + `admin/subscriptions/${pendingRenewal.new_subscription_id}/renew/confirm/`,
        {
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
        }
      );
      showToast(`${selected.subscriber_name}'s subscription renewed.`);
      closeRenewModal();
      fetchRenewals();
    } catch {
      showToast('Payment succeeded but confirmation failed. Please retry confirmation.', 'error');
    } finally {
      setConfirming(false);
    }
  };

  const confirmPaymentManually = async () => {
    if (!pendingRenewal || !selected) return;
    setConfirming(true);
    try {
      await axios.post<RenewConfirmResponse>(
        BaseUrl + `admin/subscriptions/${pendingRenewal.new_subscription_id}/renew/confirm/`
      );
      showToast(`${selected.subscriber_name}'s subscription renewed.`);
      closeRenewModal();
      fetchRenewals();
    } catch {
      showToast('Could not confirm the payment. Please try again.', 'error');
    } finally {
      setConfirming(false);
    }
  };

  const openRazorpayCheckout = async () => {
    if (!pendingRenewal || !selected) return;

    if (!razorpayReady.current) {
      const ok = await loadRazorpayScript();
      if (!ok) {
        showToast('Could not load Razorpay checkout. Check your connection and try again.', 'error');
        return;
      }
      razorpayReady.current = true;
    }

    if (!pendingRenewal.razorpay_key_id || !pendingRenewal.razorpay_order_id) {
      showToast('Razorpay order details missing from the server response.', 'error');
      return;
    }

    const options = {
      key: pendingRenewal.razorpay_key_id,
      amount: pendingRenewal.amount ?? Math.round(Number(selected.amount) * 100), // paise
      currency: pendingRenewal.currency ?? 'INR',
      name: 'Subscription Renewal',
      description: `${selected.plan_name} — ${selected.subscriber_name}`,
      order_id: pendingRenewal.razorpay_order_id,
      prefill: {
        name: selected.subscriber_name,
        email: selected.subscriber_email || undefined,
      },
      notes: {
        order_code: pendingRenewal.order_code,
        subscription_id: String(pendingRenewal.new_subscription_id),
      },
      theme: { color: '#0b1f3a' }, // adjust to match your navy brand color
      handler: (response: {
        razorpay_payment_id: string;
        razorpay_order_id: string;
        razorpay_signature: string;
      }) => {
        confirmPaymentWithRazorpay(response);
      },
      modal: {
        ondismiss: () => {
          // Admin closed the checkout without paying — leave pendingRenewal
          // as-is so they can retry from the same modal.
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', (resp: any) => {
      showToast(`Payment failed: ${resp?.error?.description || 'please retry.'}`, 'error');
    });
    rzp.open();
  };

  const openLapseConfirm = (row: SubscriptionRow) => {
    setLapseTarget(row);
    setLapseConfirmOpen(true);
  };

  const confirmMarkAsLapsed = async () => {
    if (!lapseTarget) return;
    setLapsing(true);
    try {
      await axios.post(BaseUrl + `admin/subscriptions/${lapseTarget.id}/mark-lapsed/`, {});
    } catch {
      // Backend mark-lapsed endpoint may not exist yet — proceed anyway.
    }
    showToast(`${lapseTarget.subscriber_name}'s subscription marked as lapsed.`);
    setLapsing(false);
    setLapseConfirmOpen(false);
    setLapseTarget(null);
    fetchRenewals();
  };

  const canAct = (row: SubscriptionRow) =>
    row.status?.toLowerCase() !== 'expired' && row.status?.toLowerCase() !== 'cancelled';

  const columns: Column<SubscriptionRow>[] = [
    {
      key: 'user', header: 'Subscriber', render: r => (
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-navy text-white flex items-center justify-center font-black text-[12px] shrink-0">
            {r.subscriber_name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
          </div>
          <div>
            <p className="font-bold text-gray-900">{r.subscriber_name}</p>
            {r.subscriber_email && <p className="text-[11px] text-gray-400 font-medium">{r.subscriber_email}</p>}
          </div>
        </div>
      )
    },
    { key: 'plan', header: 'Plan', render: r => r.plan_name },
    { key: 'expiry', header: 'Expiry', render: r => formatDate(r.expiry) },
    {
      key: 'days',
      header: 'Days',
      render: r => (
        <span className={r.days <= 0 ? 'text-red-600 font-semibold' : ''}>
          {r.days}d
        </span>
      ),
    },
    {
      key: 'reminders',
      header: 'Reminders',
      render: r => (
        <div className="flex flex-col gap-1">
          {r.reminders?.map((rem, idx) => (
            <span
              key={idx}
              className={`px-2 py-0.5 text-xs rounded-full border w-fit ${rem.due
                  ? 'bg-amber-100 text-amber-700 border-amber-200'
                  : 'bg-green-100 text-green-700 border-green-200'
                }`}
            >
              ⟳ {rem.label}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: 'status', header: 'Status', render: r => (
        <Badge tone={statusToTone(r.status)}>{r.status}</Badge>
      )
    },
    {
      key: 'payment_status', header: 'Payment', render: r => (
        <Badge tone={r.payment_status?.toLowerCase() === 'paid' ? 'green' : 'amber'}>{r.payment_status || '—'}</Badge>
      )
    },
    { key: 'amount', header: 'Amount', render: r => formatAmount(r), align: 'right' },
    {
      key: 'actions', header: '', align: 'right', render: r => (
        <div className="flex items-center justify-end gap-1.5">
          <button
            title="Renew"
            onClick={() => openRenewModal(r)}
            disabled={!canAct(r)}
            className="w-8 h-8 rounded-lg flex items-center justify-center text-navy hover:text-navy hover:bg-gray-50 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-400"
          >
            <FontAwesomeIcon icon={faRotateRight} className="text-[13px]" />
          </button>
          <button
            title="Mark as lapsed"
            onClick={() => openLapseConfirm(r)}
            disabled={!canAct(r)}
            className="w-8 h-8 rounded-lg flex items-center justify-center text-red-600 hover:text-red-600 hover:bg-red-50 transition-colors disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-gray-400"
          >
            <FontAwesomeIcon icon={faUserXmark} className="text-[13px]" />
          </button>
        </div>
      )
    },
  ];

  return (
    <div>
      <PageHeader
        title="Renewals"
        subtitle="Subscriptions due or coming due for renewal."
      />

      <Card>
        <CardHeader title="Subscriptions" subtitle="" />

        <div className="flex items-center justify-between gap-3 px-1 pb-4">
          <div className="relative w-full max-w-xs">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300 text-[12px]" />
            <input
              type="text"
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
              placeholder="Search by subscriber, plan…"
              className="w-full pl-8 pr-3 py-2 text-[13px] font-medium border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy/20 focus:border-navy"
            />
          </div>
          <span className="text-[12px] text-gray-400 font-semibold whitespace-nowrap">
            {count} {count === 1 ? 'result' : 'results'}
          </span>
        </div>

        <DataTable
          columns={columns}
          rows={rows}
          loading={loading}
          emptyTitle="No renewals found"
          emptySubtitle={search ? 'Try a different search term.' : 'Nothing is due for renewal right now.'}
        />

        {count > PAGE_SIZE && (
          <div className="flex items-center justify-between px-1 pt-4">
            <span className="text-[12px] text-gray-400 font-semibold">
              Page {pageNum} of {totalPages}
            </span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setPageNum(p => Math.max(1, p - 1))}
                disabled={pageNum <= 1 || loading}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:hover:bg-transparent"
              >
                <FontAwesomeIcon icon={faChevronLeft} className="text-[12px]" />
              </button>
              <button
                onClick={() => setPageNum(p => Math.min(totalPages, p + 1))}
                disabled={pageNum >= totalPages || loading}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 border border-gray-200 hover:bg-gray-50 disabled:opacity-30 disabled:hover:bg-transparent"
              >
                <FontAwesomeIcon icon={faChevronRight} className="text-[12px]" />
              </button>
            </div>
          </div>
        )}
      </Card>

      {renewModalOpen && selected && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
          onClick={() => !renewing && !confirming && closeRenewModal()}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-full max-w-md p-6"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-[15px] font-black text-gray-900">Renew subscription</h3>
                <p className="text-[12px] text-gray-500 font-medium mt-0.5">
                  {selected.subscriber_name} · {selected.plan_name}
                </p>
              </div>
              <button
                onClick={closeRenewModal}
                disabled={renewing || confirming}
                className="text-gray-400 hover:text-gray-600"
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>

            {!pendingRenewal ? (
              <>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 mb-6 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Customer</span>
                    <span className="text-[13px] font-black text-gray-900">{selected.subscriber_name}</span>
                  </div>
                  {selected.subscriber_email && (
                    <div className="flex items-center justify-between">
                      <span className="text-[12px] font-bold text-gray-500">Email</span>
                      <span className="text-[13px] font-semibold text-gray-700 truncate max-w-[220px]">
                        {selected.subscriber_email}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Plan</span>
                    <span className="text-[13px] font-black text-gray-900">{selected.plan_name}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Amount</span>
                    <span className="text-[13px] font-black text-gray-900">{formatAmount(selected)}</span>
                  </div>
                  {selected.reminders?.length > 0 && (
                    <div className="flex items-start justify-between pt-1">
                      <span className="text-[12px] font-bold text-gray-500 pt-0.5">Reminders</span>
                      <div className="flex flex-col items-end gap-1">
                        {selected.reminders.map((rem, idx) => (
                          <span
                            key={idx}
                            className={`px-2 py-0.5 text-xs rounded-full border w-fit ${rem.due
                                ? 'bg-amber-100 text-amber-700 border-amber-200'
                                : 'bg-green-100 text-green-700 border-green-200'
                              }`}
                          >
                            ⟳ {rem.label}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                <div className="flex items-center justify-end gap-2">
                  <Button variant="secondary" size="sm" onClick={closeRenewModal} disabled={renewing}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={createRenewal}
                    loading={renewing}
                    icon={<FontAwesomeIcon icon={faRotateRight} />}
                  >
                    Create renewal order
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 mb-6 space-y-2">
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Order</span>
                    <span className="text-[13px] font-black text-gray-900">{pendingRenewal.order_code}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">New end date</span>
                    <span className="text-[13px] font-black text-gray-900">{formatDate(pendingRenewal.new_end_date)}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Days carried forward</span>
                    <span className="text-[13px] font-black text-gray-900">{pendingRenewal.remaining_days_carried_forward}d</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-bold text-gray-500">Payment status</span>
                    <Badge tone="amber">{pendingRenewal.payment_status}</Badge>
                  </div>
                </div>

                <p className="text-[12px] text-gray-500 font-medium mb-4">
                  Collect payment via Razorpay, or confirm manually if payment was received outside checkout.
                </p>

                <div className="flex items-center justify-end gap-2">
                  <Button variant="secondary" size="sm" onClick={closeRenewModal} disabled={confirming}>
                    Cancel
                  </Button>
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={confirmPaymentManually}
                    loading={confirming}
                  >
                    Confirm manually
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={openRazorpayCheckout}
                    loading={confirming}
                    icon={<FontAwesomeIcon icon={faCreditCard} />}
                  >
                    Pay with Razorpay
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <ConfirmDialog
        open={lapseConfirmOpen}
        onClose={() => !lapsing && setLapseConfirmOpen(false)}
        onConfirm={confirmMarkAsLapsed}
        title="Mark as lapsed"
        message={lapseTarget ? `Mark ${lapseTarget.subscriber_name}'s "${lapseTarget.plan_name}" subscription as lapsed? They'll lose access until it's renewed, and this subscriber will move to the Lapsed list.` : ''}
        confirmLabel="Mark as lapsed"
        danger
        loading={lapsing}
      />

      <Toast message={toast} />
    </div>
  );
}

export default RenewSubscription;